<template>
  <template v-if="isNetPurchase">
    <NumberInput
      id="catalog-margin"
      :model-value="sellValue"
      label="Marge (%)"
      :min="0"
      :max="95"
      :step="0.1"
      @update:model-value="$emit('update:sellValue', $event)"
    />
    <div />
    <p class="catalog-agreement__hint">
      Deze lijst is een netto inkooplijst. De cel is jouw inkoop. Verkoop = inkoop / (1 −
      marge/100), zoals bij je eigen producten.
    </p>
  </template>
  <template v-else>
    <NumberInput
      id="catalog-purchase"
      :model-value="purchaseMarginPct"
      label="Inkoopkorting (%)"
      :min="0"
      :max="99"
      :step="0.1"
      @update:model-value="$emit('update:purchaseMarginPct', $event)"
    />
    <div />
    <p class="catalog-agreement__hint">
      Korting op de brutoprijs uit het prijsboekje{{ inclNote }}. Daarmee wordt jouw inkoop
      gecontroleerd. De klantprijs verandert hier niet van.
    </p>
    <SelectInput
      id="catalog-sell-type"
      :model-value="sellType"
      label="Verkoopafspraak"
      :options="sellTypeOptions"
      @update:model-value="$emit('update:sellType', $event)"
    />
    <NumberInput
      id="catalog-sell-value"
      :model-value="sellValue"
      :label="sellValueLabel"
      :step="0.01"
      @update:model-value="$emit('update:sellValue', $event)"
    />
    <p class="catalog-agreement__hint">Leeg betekent: de klant betaalt de brochureprijs.</p>
  </template>
</template>

<script>
  import { computed } from 'vue';
  import NumberInput from '@/components/inputs/NumberInput.vue';
  import SelectInput from '@/components/inputs/SelectInput.vue';

  export const PRICE_BASIS_LABELS = {
    brochure_incl_vat: 'Brochureprijs incl. btw',
    brochure_excl_vat: 'Brochureprijs excl. btw',
    net_purchase_excl_vat: 'Netto inkooplijst excl. btw',
  };

  export default {
    name: 'CatalogAgreementFields',
    components: { NumberInput, SelectInput },
    props: {
      priceBasis: { type: String, default: 'brochure_excl_vat' },
      purchaseMarginPct: { type: [Number, String], default: 0 },
      sellType: { type: String, default: 'percent' },
      sellValue: { type: [Number, String], default: 0 },
    },
    emits: ['update:purchaseMarginPct', 'update:sellType', 'update:sellValue'],
    setup(props) {
      const isNetPurchase = computed(() => props.priceBasis === 'net_purchase_excl_vat');
      const inclNote = computed(() =>
        props.priceBasis === 'brochure_incl_vat' ? ', na aftrek van btw' : ''
      );
      const sellTypeOptions = [
        { value: 'percent', label: 'Percentage op de brochureprijs' },
        { value: 'amount', label: 'Vast bedrag' },
      ];
      const sellValueLabel = computed(() =>
        props.sellType === 'amount' ? 'Bedrag excl. btw' : 'Percentage'
      );
      return { isNetPurchase, inclNote, sellTypeOptions, sellValueLabel };
    },
  };
</script>

<style scoped lang="scss">
  .catalog-agreement__hint {
    grid-column: 1 / -1;
    margin: -0.25rem 0 0;
    color: var(--slate-500);
    @include fontSize('sm');
  }
</style>
